import { CookiesPreferencesDrawer } from './cookiesPreferencesDrawer';

export const AppDrawers = () => {
	return (
		<>
			<CookiesPreferencesDrawer />
		</>
	);
};
